import { render } from "./TextboxField.vue?vue&type=template&id=356fdf14"
import script from "./TextboxField.vue?vue&type=script&lang=ts"
export * from "./TextboxField.vue?vue&type=script&lang=ts"
script.render = render

export default script